export default [{
  path: 'raw_html',
  name: 'workspace.key.raw_html',
  component: () => import('@/modules/DocxView'),
  meta: {}
},
{
  path: 'convert_html',
  name: 'workspace.key.convert_html',
  component: () => import('@/modules/ConvertHtml'),
  meta: {}
},
{
  path: 'json_view',
  name: 'workspace.key.json_view',
  component: () => import('@/modules/JsonView'),
  meta: {}
},
{
  path: 'image_view',
  name: 'workspace.key.image',
  component: () => import('@/modules/ImageView'),
  meta: { }
},
{
  path: 'image_view2',
  name: 'workspace.key.image2',
  component: () => import('@/modules/ImageView2'),
  meta: { }
},
{
  path: 'ocr_text',
  name: 'workspace.key.ocr_text',
  component: () => import('@/modules/OCRView'),
  meta: { }
},
{
  path: 'ocr_editor',
  name: 'workspace.key.ocr_editor',
  component: () => import('@/modules/OCREditor'),
  meta: { }
},
{
  path: 'text_compare',
  name: 'workspace.key.text_compare',
  component: () => import('@/modules/TextCompare'),
  meta: { }
},
{
  path: 'preprocess',
  name: 'workspace.key.preprocess',
  component: () => import('@/modules/CleanTextView'),
  meta: { }
},
{
  path: 'preprocess_s',
  name: 'workspace.key.preprocess_s',
  component: () => import('@/modules/CleanTextEditor'),
  meta: { }
},
{
  path: 'structurize',
  name: 'workspace.key.structurize',
  component: () => import('@/modules/StructurizeView'),
  meta: { }
},
{
  path: 'topic_classification',
  name: 'workspace.key.topic_classification',
  component: () => import('@/modules/ClassifyTextView'),
  meta: { }
},
{
  path: 'topic',
  name: 'workspace.key.topic',
  component: () => import('@/modules/TopicTextView'),
  meta: { }
},
{
  path: 'entity_extraction',
  name: 'workspace.key.entity_extraction',
  component: () => import('@/modules/EntityExtraction'),
  meta: { }
},
{
  path: 'entity_extraction2',
  name: 'workspace.key.entity_extraction2',
  component: () => import('@/modules/EntityExtraction2'),
  meta: { }
},
{
  path: 'bank_entity_extraction',
  name: 'workspace.key.bank_entity_extraction',
  component: () => import('@/modules/BankEntityExtraction'),
  meta: { }
},
{
  path: 'named_entity_recognition',
  name: 'workspace.key.named_entity_extraction',
  component: () => import('@/modules/NamedEntityRecognition'),
  meta: { }
},
{
  path: 'vocab_diff',
  name: 'workspace.key.vocab_diff',
  component: () => import('@/modules/VocabularyDiff'),
  meta: { }
},
{
  path: 'table_analysis',
  name: 'workspace.key.table_analysis',
  component: () => import('@/modules/TableAnalysis'),
  meta: { }
},
{
  path: 'table_automation',
  name: 'workspace.key.table_automation',
  component: () => import('@/modules/TableAutomation'),
  meta: { }
},
{
  path: 'table_structure_recognition',
  name: 'workspace.key.table_structure_recognition',
  component: () => import('@/modules/TableStructureRecognition'),
  meta: { }
},
{
  path: 'field_extraction',
  name: 'workspace.key.field_extraction',
  component: () => import('@/modules/TextAutomation'),
  meta: { }
},
{
  path: 'ocr_text_image',
  name: 'workspace.key.ocr_text_image',
  component: () => import('@/modules/TextImageView'),
  meta: { }
},
{
  path: 'ocr_text_detection',
  name: 'workspace.key.ocr_text_detection',
  component: () => import('@/modules/TextDetectionView'),
  meta: { }
},
{
  path: 'ocr_object_detection',
  name: 'workspace.key.ocr_object_detection',
  component: () => import('@/modules/ObjectDetectionView'),
  meta: { }
},
{
  path: 'ocr_text_recognition',
  name: 'workspace.key.ocr_text_recognition',
  component: () => import('@/modules/TextRecognitionView'),
  meta: { }
},
{
  path: 'ocr_tag_text',
  name: 'workspace.key.ocr_tag_text',
  component: () => import('@/modules/TagTextView'),
  meta: { }
},
{
  path: 'text_relation',
  name: 'workspace.key.text_relation',
  component: () => import('@/modules/TextRelation'),
  meta: { }
},
{
  path: 'information_summary',
  name: 'workspace.key.information_summary',
  component: () => import('@/modules/InformationSummaryView'),
  meta: { }
},
{
  path: 'tag_region',
  name: 'workspace.key.tag_region',
  component: () => import('@/modules/TagRegionView'),
  meta: { }
},
{
  path: 'tag_region2',
  name: 'workspace.key.tag_region2',
  component: () => import('@/modules/TagRegionView2'),
  meta: { }
},
{
  path: 'text_nlp_summary',
  name: 'workspace.key.text_nlp_summary',
  component: () => import('@/modules/NLPSummaryView'),
  meta: { }
},
{
  path: 'full_text_classify',
  name: 'workspace.key.full_text_classify',
  component: () => import('@/modules/FullTextClassifyView'),
  meta: { }
},
{
  path: 'full_text_labeling',
  name: 'workspace.key.full_text_labeling',
  component: () => import('@/modules/FullTextLabelingView'),
  meta: { }
},
{
  path: 'classify_table',
  name: 'workspace.key.classify_table',
  component: () => import('@/modules/ClassifyTableView'),
  meta: { }
},
{
  path: 'classify_table2',
  name: 'workspace.key.classify_table2',
  component: () => import('@/modules/ClassifyTableView2'),
  meta: { }
},
{
  path: 'extraction_review',
  name: 'workspace.key.extraction_review',
  component: () => import('@/modules/ExtractionReview'),
  meta: {}
},
{
  path: 'consignation_review',
  name: 'workspace.key.consignation_review',
  component: () => import('@/modules/ConsignationReview'),
  meta: {}
},
{
  path: 'config_keywords_review',
  name: 'workspace.key.config_keywords_review',
  component: () => import('@/modules/ConfigKeywordsReview'),
  meta: {}
},
{
  path: 'relation_extraction',
  name: 'workspace.key.relation_extraction',
  component: () => import('@/modules/RelationExtraction'),
  meta: {}
},
{
  path: 'layout',
  name: 'workspace.key.layout',
  component: () => import('@/modules/Layout'),
  meta: {}
}]
